import { observer } from 'mobx-react-lite'
import type { FunctionComponent } from 'react'

import { LinkButton } from '@components/button/link'
import type {
    ButtonTrackingProps,
    CommonButtonProps,
} from '@components/button/props'
import type { ActionDownloadFileFragment } from '@graphql/fragments/ActionDownloadFileFragment.graphql'
import type { ActionRemoteUrlFragment } from '@graphql/fragments/ActionRemoteUrlFragment.graphql'
import type { WithTestId } from '@lib/utils/testid'

/** Action button to send the user to another website. */
export const ActionRemoteUrl: FunctionComponent<Props> = observer(
    ({
        url,
        title,
        file,
        placement,
        loading,
        containerElementId,
        size,
        ...restOfProps
    }) => (
        <LinkButton
            {...restOfProps}
            preset={restOfProps.preset}
            size={size}
            href={url}
            target={url}
            placement={placement}
            containerElementId={containerElementId}
            download={file?.source}
            loading={loading}
            {...restOfProps}
        >
            {title}
        </LinkButton>
    ),
)

type CommonProps<T> = Omit<
    T &
        WithTestId<
            Omit<ButtonTrackingProps, 'preset'> & {
                loading?: boolean
                preset?: string
            }
        >,
    'sys' | 'type'
>

type Props = CommonProps<ActionDownloadFileFragment> &
    CommonProps<ActionRemoteUrlFragment> &
    CommonButtonProps
